import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import * as userActions from '../store/actions/user'
import Loading from '../components/Loading'
import LegacyConsent from './LegacyConsent'
import StreamlinedConsent from './StreamlinedConsent'

const Consent = ({ match }) => {
  const dispatch = useDispatch()
  const { token } = match.params
  const [response, setResponse] = useState(null)

  useEffect(() => {
    dispatch(userActions.checkConsumer(token))
      .then((res) => {
        if (res && res.data) {
          setResponse(res.data)
        }
      })
  }, [dispatch, token])

  if (!response) {
    return <Loading/>
  }

  if (response.code) {
    return <StreamlinedConsent response={response} match={match}/>
  }

  return <LegacyConsent response={response} match={match}/>
}

export default Consent
